import React, { Component, createRef } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Modal from "react-modal";
import Modal_Empleado_Empresa from "./modal_empleado_empresa";
import Modal_Upload_Data from "../carga_empleados/modal_upload_data";
import "./modal.css";
import firebase from "firebase";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import { ta } from "date-fns/locale";

const database = firebase.database();

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "450px",
  },
};

class EmpleadoEmpresa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empleados: [],
      isActive: false,
      codigo_empresa: "",
      correo: "",
      dui: "",
      numero_empleado: "",
      pasaporte: "",
      nombre: "",
      apellido: "",
      nombre_titulo: "",
      isModalOpen: false,
      isOpen: false,
      authUser: null,
    };
    this.dropdownRef = createRef();
    this.empleadosRef = database
      .ref()
      .child("Clientes")
      .orderByChild("socio")
      .equalTo(this.props.match.params.idempresa);
    this.empresaRef = database
      .ref()
      .child("Clientes")
      .orderByChild("socio")
      .equalTo(this.props.match.params.idempresa);
    this.socio = this.props.match.params.idempresa;
    console.log("SOCIO => ", this.socio);
    this.handleClick = this.handleClick.bind(this);
    this.toggleModalUpdate = this.toggleModalUpdate.bind(this);
    this.toggleModalUpload = this.toggleModalUpload.bind(this);
  }

  componentWillMount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidMount() {
    this.empresaRef.once("value", this.gotData, this.errData);
    document.addEventListener("mousedown", this.handleClickOutside);
    this.empresaRef = database.ref().child(`Empresa/${this.socio}`);

    this.empresaRef.once("value", (snapshot) => {
      if (snapshot.exists()) {
        const empresaData = snapshot.val();
        this.setState({ authUser: empresaData.codigo_empresa });
        console.log("Empresa => ", this.state.authUser);
      } else {
        console.log("No se encontró la empresa con ese UID.");
      }
    });
  }

  gotData = (data) => {
    let newEmpleados = [];
    const empleadodata = data.val();

    if (empleadodata != null) {
      const keys = Object.keys(empleadodata);

      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];

        newEmpleados.push({
          key: k,
          nombre: empleadodata[k].nombre,
          apellido: empleadodata[k].apellido,
          codigo_empresa: empleadodata[k].codigo_empresa,
          correo: empleadodata[k].correo,
          dui: empleadodata[k].dui,
          numero_empleado: empleadodata[k].numero_empleado,
          pasaporte: empleadodata[k].pasaporte,
        });
      }
      this.setState({ empleados: newEmpleados });
    }
  };

  errData = (err) => {
    console.log(err);
  };

  btnEditFormatter(cell, row) {
    return (
      <button
        className="btn btn-success btn-sm"
        onClick={() => {
          this.handleClick(row);
        }}
      >
        Editar
      </button>
    );
  }

  handleClick = (rowKey) => {
    this.setState({
      correo: rowKey.correo,
      dui: rowKey.dui,
      numero_empleado: rowKey.numero_empleado,
      pasaporte: rowKey.pasaporte,
    });

    this.toggleModalUpdate();
  };

  toggleModalUpdate = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };

  toggleModalUpload() {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  downloadTemplate = () => {
    // Definir las columnas del archivo Excel
    const columnsPlantilla = [
      {
        nombre: "",
        apellido: "",
        correo: "",
        password: "",
        numero_empleado: "",
        pasaporte: "",
        dui: "",
        codigo_centro_costo: "",
        areaDesc: "",
      },
    ];

    // Crear una hoja de cálculo desde los datos
    const worksheet = XLSX.utils.json_to_sheet(columnsPlantilla, {
      header: [
        "nombre",
        "apellido",
        "correo",
        "password",
        "numero_empleado",
        "pasaporte",
        "dui",
        "codigo_centro_costo",
        "areaDesc",
      ],
    });

    // Crear un libro de trabajo y agregar la hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla");

    // Generar el archivo Excel y convertirlo a un Blob
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace y descargar el archivo
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = "plantilla-empleados.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  downloadData = () => {
    if (!this.empleadosRef) {
      alert("No se puede acceder a la referencia de la base de datos.");
      return;
    }

    console.log("EMPRESA REF => ", this.empleadosRef);

    this.empleadosRef.once("value", (snapshot) => {
      const empleadodata = snapshot.val();

      if (!empleadodata) {
        alert("No hay datos disponibles para descargar.");
        return;
      }

      const empleados = Object.keys(empleadodata).map((key) => ({
        _ID: key,
        nombre: empleadodata[key].nombre || "",
        apellido: empleadodata[key].apellido || "",
        correo: empleadodata[key].correo || "",
        numero_empleado: empleadodata[key].numero_empleado || "",
        pasaporte: empleadodata[key].pasaporte || "",
        dui: empleadodata[key].dui || "",
        codigo_centro_costo: empleadodata[key].centro || "",
        areaDesc: empleadodata[key].areaDesc || "",
      }));

      console.log("EMPPLEADO DATA S1 => ", empleados);

      // Crear la hoja de cálculo principal
      const worksheet = XLSX.utils.json_to_sheet(
        empleados.map(({ _ID, ...rest }) => rest)
      );

      console.log("EMPPLEADO DATA S2 => ", empleados);
      // Crear una hoja separada para los IDs
      const worksheetIDs = XLSX.utils.aoa_to_sheet(
        empleados.map((empleado) => [empleado._ID])
      );

      console.log(worksheetIDs);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Empleados");
      XLSX.utils.book_append_sheet(workbook, worksheetIDs, "IDs");

      console.log("WORKBOOK S1 => ", workbook);

      // Ocultar la hoja de IDs
      if (!workbook.Workbook) workbook.Workbook = { Sheets: [] };
      workbook.Workbook.Sheets = workbook.Workbook.Sheets || [];
      workbook.Workbook.Sheets[1] = { Hidden: 1 };
      console.log("WORKBOOK S2 => ", workbook);
      // Convertir a un archivo Excel y descargarlo
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear enlace de descarga
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "empleados.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  render() {
    const { authUser } = this.state;
    return (
      <div className="EmpleadosEmpresa container">
        <h1 className="titulo">Empleados {this.props.match.params.nombre}</h1>

        <Link to="/empresa">
          <span className="glyphicon glyphicon-arrow-left"> </span> Empresas
        </Link>
        <br></br>
        {authUser === "Avianca" && (
          <div>
            <button
              className="btn btn-success mt-2"
              onClick={this.toggleModalUpload}
            >
              <span className="glyphicon glyphicon-plus"> </span> Cargar
              Empleados
            </button>
            {
              /* <button className="btn btn-info m-2" onClick={this.toggleModal}>
              <span className="glyphicon glyphicon-plus"> </span> Descargar
            </button> */
              <div className="dropdown" ref={this.dropdownRef}>
                <button
                  className="btn btn-info m-2"
                  onClick={this.toggleDropdown}
                >
                  <span className="glyphicon glyphicon-plus"> </span> Descargar
                </button>
                {this.state.isOpen && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item"
                      onClick={this.downloadTemplate}
                    >
                      Plantilla
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={this.downloadData}
                    >
                      Archivo con Datos
                    </button>
                  </div>
                )}
              </div>
            }
          </div>
        )}

        {/* Renderiza el modal y pasa las props */}
        <Modal_Upload_Data
          isActive={this.state.isModalOpen}
          toggleModal={this.toggleModalUpload}
          socio={this.socio}
        />

        <BootstrapTable
          data={this.state.empleados}
          ref="table"
          pagination={true}
          search={true}
          hover
        >
          <TableHeaderColumn
            dataField="key"
            isKey={true}
            dataSort={true}
            hidden
          >
            Nombre
          </TableHeaderColumn>
          <TableHeaderColumn dataField="correo" dataSort={true}>
            Correo
          </TableHeaderColumn>
          <TableHeaderColumn dataField="dui">Dui</TableHeaderColumn>
          <TableHeaderColumn dataField="numero_empleado">
            Numero de empleado
          </TableHeaderColumn>
          <TableHeaderColumn dataField="pasaporte">Pasaporte</TableHeaderColumn>
        </BootstrapTable>

        <Modal
          isOpen={this.state.isActive}
          onRequestClose={this.toggleModalUpdate}
          style={customStyles}
        >
          <form method="POST" action="" onSubmit={this.updateRow}>
            <h3>Modificar Empleado</h3>
            <hr />
            <div className="form-group">
              <label htmlFor="nombre">Nombre</label>
              <input
                type="text"
                name="nombre"
                className="form-control"
                autoComplete="off"
                placeholder="Nombre"
                defaultValue={this.state.nombre}
              />
            </div>
            <div className="form-group">
              <label htmlFor="apellido">Apellido</label>
              <input
                type="text"
                name="apellido"
                className="form-control"
                autoComplete="off"
                placeholder="Apellido"
                defaultValue={this.state.apellido}
              />
            </div>
            <div className="form-group">
              <label htmlFor="correo">Correo</label>
              <input
                type="text"
                name="correo"
                className="form-control"
                autoComplete="off"
                placeholder="Correo"
                defaultValue={this.state.correo}
              />
            </div>
            <div className="form-group">
              <label htmlFor="dui">Dui</label>
              <input
                type="text"
                name="dui"
                className="form-control"
                autoComplete="off"
                placeholder="Dui"
                defaultValue={this.state.dui}
              />
            </div>
            <div className="form-group">
              <label htmlFor="numero_empleado">Numero de empleado</label>
              <input
                type="text"
                className="form-control"
                name="numero_empleado"
                autoComplete="off"
                placeholder="Numero empleado"
                defaultValue={this.state.numero_empleado}
              />
            </div>
            <div className="form-group">
              <label htmlFor="pasaporte">Pasaporte</label>
              <input
                type="text"
                name="pasaporte"
                className="form-control"
                autoComplete="off"
                placeholder="Pasaporte"
                defaultValue={this.state.pasaporte}
              />
            </div>

            <button type="submit" className="btn btn-primary buttons">
              Guardar
            </button>
            <button
              type="button"
              className="btn btn-default buttons btnmargin"
              onClick={this.toggleModalUpdate}
            >
              Cerrar
            </button>
          </form>
        </Modal>
      </div>
    );
  }
}

export default EmpleadoEmpresa;



// WEBPACK FOOTER //
// ./src/Components/Empleados_empresa/Empleados_empresa.jsx